export default __webpack_public_path__ + "static/media/10_freedompay.ae0ac843.svg";